import Link from './src/link2.mjs';
export { linkEmits, linkProps } from './src/link.mjs';
import { withInstall } from '../../utils/vue/install.mjs';

const ElLink = withInstall(Link);

export { ElLink, ElLink as default };
//# sourceMappingURL=index.mjs.map
